// extracted by mini-css-extract-plugin
export default {"homepageTeamBanners":"Home_homepageTeamBanners__QoFTB","homepageTeamBannersMobile":"Home_homepageTeamBannersMobile__JDnwY"};